var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoEmMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "137px",
    viewBox: "0 0 101 137",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5,136 C70.6447935,95.6777181 99,79.8499122 99,51.4402478 C99,23.0305834 76.8380951,0 49.5,0 C22.1619049,0 0,23.0305834 0,51.4402478 C0,79.8499122 29.3072317,95.8878539 49.5,136 Z",
    id: "Oval",
    stroke: "#FFFFFF",
    fill: "#0ED19C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(20.000000, 32.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    points: "0 33 22 33 22 28.1915046 5.22198469 28.1915046 5.22198469 18.7630388 20.8396432 18.7630388 20.8396432 13.954297 5.22198469 13.954297 5.22198469 4.80874182 22 4.80874182 22 0 0 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(27.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    points: "27.6295987 31.8750306 33 25.1249694 33 0 30.0218227 0 16.5240803 16.7358491 3.02608696 0 0 0 0 33 5.18754181 33 5.18754181 9.52291105 16.5240803 23.477334 27.6295987 10.5001225"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    points: "27 33 33 33 33 27"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEmMap);
export default __webpack_public_path__ + "static/media/logo-em-map.ef524b8b02f79c43055444a6e498f750.svg";
export { ForwardRef as ReactComponent };